import { service } from '@ember/service';
import MessagingBase from './messaging-base';

export default class MessagingConversation extends MessagingBase {
  @service messaging;

  serialize(snapshot) {
    let json = super.serialize(...arguments);
    if (snapshot.isNew) {
      // The API doesn't accept the current user or attributes for new conversations.
      delete json.data.attributes;

      const currentUserId = this.messaging.currentProfile.id;
      json.data.relationships.users.data = filterCurrentUserFromRelationships(
        currentUserId,
        json.data.relationships.users.data
      );
    } else {
      // Conversation updates currently only accept display_name.
      json.data.attributes = {
        'display_name': json.data.attributes.display_name ?? null,
      };
      delete json.data.relationships;
    }
    return json;
  }
}

function filterCurrentUserFromRelationships(currentUserId, relationships) {
  return relationships.filter(relationship => relationship.id !== currentUserId);
}
